// Map icon utilities for different content types
export type MapIconType = 'service-offered' | 'service-needed' | 'animal' | 'current-location'

export const getMapIcon = (type: MapIconType): string => {
  switch (type) {
    case 'service-offered':
      // Green icon for services offered
      return `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C9.383 2 4 7.383 4 14C4 23.5 16 38 16 38S28 23.5 28 14C28 7.383 22.617 2 16 2Z" fill="#10B981" stroke="#ffffff" stroke-width="2"/>
        <circle cx="16" cy="14" r="6" fill="#ffffff"/>
        <path d="M13 14L15 16L19 12" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`

    case 'service-needed':
      // Blue icon for services needed  
      return `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C9.383 2 4 7.383 4 14C4 23.5 16 38 16 38S28 23.5 28 14C28 7.383 22.617 2 16 2Z" fill="#3B82F6" stroke="#ffffff" stroke-width="2"/>
        <circle cx="16" cy="14" r="6" fill="#ffffff"/>
        <path d="M13 11H19M13 14H19M13 17H17" stroke="#3B82F6" stroke-width="2" stroke-linecap="round"/>
      </svg>`

    case 'animal':
      // Orange icon for animals
      return `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C9.383 2 4 7.383 4 14C4 23.5 16 38 16 38S28 23.5 28 14C28 7.383 22.617 2 16 2Z" fill="#F97316" stroke="#ffffff" stroke-width="2"/>
        <circle cx="16" cy="14" r="6" fill="#ffffff"/>
        <path d="M13 12C13 12 14 11 16 11C18 11 19 12 19 12M13 16C13 16 14 17 16 17C18 17 19 16 19 16" stroke="#F97316" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="14" cy="13.5" r="1" fill="#F97316"/>
        <circle cx="18" cy="13.5" r="1" fill="#F97316"/>
      </svg>`

    case 'current-location':
      // Current location icon (existing)
      return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#10B981" stroke="#ffffff" stroke-width="2"/>
        <circle cx="12" cy="12" r="4" fill="#ffffff"/>
      </svg>`

    default:
      // Default icon
      return `<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C9.383 2 4 7.383 4 14C4 23.5 16 38 16 38S28 23.5 28 14C28 7.383 22.617 2 16 2Z" fill="#6B7280" stroke="#ffffff" stroke-width="2"/>
        <circle cx="16" cy="14" r="4" fill="#ffffff"/>
      </svg>`
  }
}

export const getIconForService = (service: { need: boolean }): string => {
  return getMapIcon(service.need ? 'service-needed' : 'service-offered')
}

export const getIconForAnimal = (): string => {
  return getMapIcon('animal')
}

// Helper function to create marker data for maps
export const createServiceMarker = (service: any) => ({
  lat: service.latitude || 0,
  lng: service.longitude || 0, 
  title: service.title,
  info: `${service.description.substring(0, 100)}... | ${service.price_credits} credits | ${service.provider?.username || 'Unknown'}`,
  icon: getIconForService(service)
})

export const createAnimalMarker = (animal: any, userLocation?: { lat: number, lng: number }) => ({
  lat: animal.latitude || userLocation?.lat || 0,
  lng: animal.longitude || userLocation?.lng || 0,
  title: `${animal.name} (${animal.animal_type})`,
  info: `${animal.breed ? `${animal.breed} | ` : ''}${animal.age ? `${animal.age} years old | ` : ''}${animal.description?.substring(0, 100) || 'No description'}`,
  icon: getIconForAnimal()
})